"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledQuoteButton = exports.StyledQuoteButtonsWrapper = exports.StyledQuoteDetails = exports.StyledFormWrapper = exports.StyledParagraph = exports.StyledIntro = void 0;
const ui_1 = require("@phishtool/ui");
const styled_components_1 = __importDefault(require("styled-components"));
exports.StyledIntro = styled_components_1.default.p.withConfig({ displayName: "StyledIntro", componentId: "sc-5gbbjc" }) `
  ${(props) => props.theme.responsiveTypography.body.medium};
  text-align: center;
  margin-top: 0;

  ${(props) => (0, ui_1.mq)({
    marginBottom: [props.theme.spacers.x3, props.theme.spacers.x6],
})}
`;
exports.StyledParagraph = styled_components_1.default.p.withConfig({ displayName: "StyledParagraph", componentId: "sc-zbhyx" }) `
  ${(props) => props.theme.responsiveTypography.body.medium};
  text-align: center;
  margin: 0 0 ${(props) => props.theme.spacers.x2};
`;
exports.StyledFormWrapper = styled_components_1.default.div.withConfig({ displayName: "StyledFormWrapper", componentId: "sc-18glifo" }) `
  margin: 0 auto;

  ${(0, ui_1.mq)({
    maxWidth: ['325px', '630px'],
})}

  .input-wrapper {
    ${(props) => (0, ui_1.mq)({
    marginBottom: [props.theme.spacers.x3, props.theme.spacers.x6],
})}
  }

  .code-input-wrapper {
    justify-content: space-between;

    input {
      padding: 0;
      text-align: center;

      ${(0, ui_1.mq)({
    width: ['40px', '90px'],
    height: ['40px', '90px'],
    fontSize: ['24px', '34px'],
})}
    }
  }
`;
exports.StyledQuoteDetails = styled_components_1.default.div.withConfig({ displayName: "StyledQuoteDetails", componentId: "sc-k8sv9r" }) `
  margin-bottom: ${(props) => props.theme.spacers.x6};
`;
exports.StyledQuoteButtonsWrapper = styled_components_1.default.div.withConfig({ displayName: "StyledQuoteButtonsWrapper", componentId: "sc-9dgp89" }) `
  display: flex;
  gap: ${(props) => props.theme.spacers.x3};
  justify-content: center;
  align-items: center;

  ${(0, ui_1.mq)({
    flexDirection: ['column', 'row'],
})}

  & > * {
    flex: 1;
    width: 100%;

    ${(0, ui_1.mq)({
    maxWidth: ['203px', '225px'],
})}
  }
`;
exports.StyledQuoteButton = styled_components_1.default.a.withConfig({ displayName: "StyledQuoteButton", componentId: "sc-1m88ntb" }) `
  display: flex;
  flex-direction: column;
  gap: ${(props) => props.theme.spacers.x3};
  font-weight: ${(props) => props.theme.fontWeights.semiBold};
  text-decoration: none;
  align-items: center;
  border: 1px solid ${(props) => props.theme.colors.silverPearl};
  border-radius: ${(props) => props.theme.radii.primary};
  padding: ${(props) => props.theme.spacers.x4} 0;

  ${(props) => props.$disabled &&
    `
    cursor: not-allowed;
  `}

  &,
  &:focus,
  &:active,
  &:visited {
    color: ${(props) => props.theme.colors.oxfordBlue};
  }

  ${(props) => props.theme.responsiveTypography.body.medium};

  svg {
    color: ${(props) => (0, ui_1.hexToRgba)(props.theme.colors.oxfordBlue, 0.2)};
  }

  &:hover {
    color: ${(props) => props.theme.colors.heroOrange};
    border-color: ${(props) => props.theme.colors.heroOrange};
    svg {
      color: ${(props) => props.theme.colors.heroOrange};
    }
  }
`;
